import { type ICustomFieldType } from 'entities/CustomField/api'
import { CustomFieldModalStore } from 'entities/CustomField/ui/CustomFieldModal/store/CustomFieldModalStore'

type IEditCustomFieldParams = {
  editId: number
  name: string
  fieldType: ICustomFieldType
  visible: boolean
}

export const editCustomFieldAction = (
  params: IEditCustomFieldParams,
  onSuccess: () => Promise<void>
) => {
  new CustomFieldModalStore({
    editId: params.editId,
    initial: {
      name: params.name,
      fieldType: params.fieldType,
      visible: params.visible,
    },
    onSuccess,
  })
}
